import React from "react";
import { LoginForm } from "@/features/auth";

/**
 * LoginPage - Wrapper 컴포넌트
 * 레이아웃만 담당하고 로직은 features/auth에서 관리
 */
export const LoginPage = () => {
  return (
    <div className="flex-1 flex items-center justify-center p-4 bg-gradient-to-br from-gray-50 to-gray-100 max-w-2xl mx-auto">
      <LoginForm />
    </div>
  );
};
